import type { CaptureMode } from "./target";

export interface InternalQualityPolicy {
  analysisWidth: number;
  analysisFps: number;
  minimumCoverage: number;
  maximumCoverage: number;
  maximumCenterOffset: number;
  minimumSharpness: number;
  minimumContrast: number;
  minimumExposure: number;
  maximumGlare: number;
  maximumMotion: number;
  minimumRidgeClarity: number;
}

export const DEFAULT_QUALITY_POLICY: Readonly<InternalQualityPolicy> = {
  analysisWidth: 360,
  analysisFps: 10,
  minimumCoverage: 0.22,
  maximumCoverage: 0.96,
  maximumCenterOffset: 0.34,
  minimumSharpness: 0.18,
  minimumContrast: 0.16,
  minimumExposure: 0.58,
  maximumGlare: 0.18,
  maximumMotion: 0.1,
  minimumRidgeClarity: 0.12,
};

export const FOUR_FINGER_QUALITY_POLICY: Readonly<InternalQualityPolicy> = {
  ...DEFAULT_QUALITY_POLICY,
  analysisWidth: 540,
  analysisFps: 8,
  minimumCoverage: 0.28,
  maximumCenterOffset: 0.3,
  minimumSharpness: 0.14,
  minimumRidgeClarity: 0.1,
  maximumMotion: 0.12,
};

export function qualityPolicyFor(
  captureMode: CaptureMode,
): Readonly<InternalQualityPolicy> {
  return captureMode === "four-fingers"
    ? FOUR_FINGER_QUALITY_POLICY
    : DEFAULT_QUALITY_POLICY;
}

export function placementPolicyFor(
  captureMode: CaptureMode,
): Readonly<InternalQualityPolicy> {
  return {
    ...qualityPolicyFor(captureMode),
    analysisWidth: 240,
    analysisFps: 4,
  };
}

export const PLACEMENT_STABLE_MS = 400;
export const FOCUS_SETTLE_MS = 800;

export const DEFAULT_CAPTURE_OPTIONS = {
  finger: "unspecified",
  timeoutMs: 45_000,
  stableDurationMs: PLACEMENT_STABLE_MS,
  burstFrames: 3,
  cameraFacing: "environment",
} as const;
